import styled from "styled-components";


export const DenmarkResponsibleGamingButtonsBox = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    
    @media ${({theme}) =>  theme.mediaQuery.sAndBelow} {
        margin-left: 20px;
    }
`